import { EventEmitter, Injectable, Output } from "@angular/core";
import {
  CameraPreview,
  CameraPreviewPictureOptions,
  CameraPreviewOptions,
  CameraPreviewDimensions,
} from "@awesome-cordova-plugins/camera-preview/ngx";
import { Platform } from "@ionic/angular";
import { Device } from "@ionic-native/device/ngx";
import { TouchID } from "@ionic-native/touch-id/ngx";
import { AndroidFingerprintAuth } from "@ionic-native/android-fingerprint-auth/ngx";
import * as JsEncryptModule from "jsencrypt";
import { RSAKey } from "jsrsasign";
import { Diagnostic } from "@ionic-native/diagnostic/ngx";
import { Dialogs } from "@ionic-native/dialogs/ngx";
import { HTTP } from "@ionic-native/http/ngx";
import { Camera, CameraOptions } from "@awesome-cordova-plugins/camera/ngx";
import { ObservableService } from "./observable.service";
import { combineLatest, from } from "rxjs";
import { AppVersion } from "@awesome-cordova-plugins/app-version/ngx";
import { IAppVersionInfo } from "./models/app-common.model";
import { NativeStorageService } from "./services/mobile/native-storage.service";

declare var window: any;
declare var cordova: any;
declare var $: any;

@Injectable({
  providedIn: "root",
})
export class MobileService {
  @Output() appReady: EventEmitter<any>;
  @Output() deviceAuth: EventEmitter<any>;

  KEY_SIZE: string = "1024";
  RSA_ALG: string = "sha256";
  doEnableSecureHTTP: boolean = false;
  bypassIRoot: boolean = false;
  keyboardHeight: number = 0;

  isPINConfigured: boolean = false;
  isFaceIDConfigured: boolean = false;
  appVersionInfo: IAppVersionInfo;

  deviceID: string = "";
  isRemoteNotificationsEnabled: boolean = false;
  isNFCPresent: boolean = false;
  isNFCEnabled: boolean = false;
  isNFCAvailable: boolean = false;
  isFaceIDAvailable: boolean = false;
  isTouchIDAvailable: boolean = false;
  isDeviceAuthAvailable: boolean = false;
  doAlertRegDeviceAuth: boolean = true;
  tapPay: any;
  downloadTimer: any;

  isDeviceRegistered: boolean = true;

  constructor(
    private cameraPreview: CameraPreview,
    public device: Device,
    private platform: Platform,
    private touchId: TouchID,
    private androidFingerprintAuth: AndroidFingerprintAuth,
    private diagnostic: Diagnostic,
    private dialogs: Dialogs,
    private secureHTTP: HTTP,
    private camera: Camera,
    private observerable: ObservableService,
    private _appVersion: AppVersion,
    private _nativeStorage: NativeStorageService
  ) {}

  private cameraPreviewOpts: CameraPreviewOptions = {
    x: 0,
    y: 0,
    width: window.screen.width,
    height: window.screen.height,
    camera: this.cameraPreview.CAMERA_DIRECTION.BACK, // Front/back camera
    toBack: true, // Set to true if you want your html in front of your preview
    tapPhoto: false, // Tap to take photo
    tapFocus: true, // Tap to focus
    previewDrag: false,
    storeToFile: false,
  };

  // picture options
  private pictureOpts: CameraPreviewPictureOptions = {
    width: 1280,
    height: 1280,
    quality: 72,
  };
  private options: CameraOptions = {
    quality: 85,
    targetWidth: 1024,
    targetHeight: 1024,
    destinationType: this.camera.DestinationType.DATA_URL,
    encodingType: this.camera.EncodingType.JPEG,
    sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
    mediaType: this.camera.MediaType.PICTURE,
    correctOrientation: true,
  };

  public picture: any;
  callbackMethod: any;

  isHybrid() {
    return window["cordova"] ? true : false;
  }

  startTakePiture(options, callback) {
    if (callback) this.callbackMethod = callback;
    this.takePicture();
  }
  takeSelfie() {
    var promise = new Promise((resolve, reject) => {
      let options = { ...this.cameraPreviewOpts };
      options.camera = this.cameraPreview.CAMERA_DIRECTION.FRONT;
      this.cameraPreview.startCamera(options);

      document.body.classList.add("camera-preview-mode");
      document.querySelector("html").classList.add("camera-preview-mode");
      var bodyContent = document.getElementsByTagName("app-root")[0];
      bodyContent["style"].visibility = "hidden";

      // Create a rectangle & buttons
      var wrapper = document.createElement("div");
      var overlayWrapper = document.createElement("div");

      document.body.appendChild(wrapper);
      wrapper.appendChild(overlayWrapper);

      var helpText = document.createElement("div");
      var faceFrame = document.createElement("div");
      var take_pic_btn = document.createElement("button");
      var galleryBtn = document.createElement("button");
      galleryBtn.type = "button";
      galleryBtn.name = "gallery";
      galleryBtn.value = "gallery";
      galleryBtn.type = "button";
      galleryBtn.innerHTML = "Gallery";

      overlayWrapper.appendChild(faceFrame);
      overlayWrapper.appendChild(helpText);
      overlayWrapper.appendChild(galleryBtn);
      overlayWrapper.appendChild(take_pic_btn);

      var helpHeader = document.createElement("h1");
      helpHeader.innerHTML = "Take a Selfie";
      var helpDesc = document.createElement("p");
      helpDesc.innerHTML =
        "Position your head in the green circle for a best result.";
      helpText.appendChild(helpHeader);
      helpText.appendChild(helpDesc);

      wrapper.className += "camera-preview-div preview-overlay";
      overlayWrapper.className += "overlay-wraper";
      helpText.className += "cphelp-text-wrapper";

      faceFrame.className += "face-oval-frame";
      galleryBtn.className += "gallery-button";
      take_pic_btn.className += "capture-button";

      var croppedBase64Img = "";

      // Get rectangle coordinates
      var _this = this;
      take_pic_btn.onclick = function () {
        var rect_coords = faceFrame.getBoundingClientRect();
        var rect_width = 262,
          rect_height = rect_coords.height;
        //var x_coord = rect_coords.width/2 - rect_width / 2, y_coord = rect_coords.height / 2 - rect_height / 2;
        var x_coord = rect_coords.left + rect_coords.width / 2 - rect_width / 2,
          y_coord = rect_coords.top;
        _this.cameraPreview.takePicture().then(
          (imageData) => {
            _this.crop(
              imageData,
              rect_width,
              rect_height,
              x_coord,
              y_coord,
              function (cropped_img_base64) {
                _this.resizeImage(cropped_img_base64, function (resizedBase64) {
                  croppedBase64Img = resizedBase64;
                  // setTimeout(function () {
                  _this.cameraPreview.stopCamera();
                  _this.cleanCameraUI();
                  // }, 500, _this);
                  resolve({ base64: resizedBase64, source: "camera" });
                });
              }
            );
          },
          (err) => {
            _this.cleanCameraUI();
            reject("Error");
          }
        );
      };
      galleryBtn.onclick = function () {
        _this.openGallery(resolve, reject);
      };
    });
    return promise;
  }
  openGallery(resolve, reject) {
    this.camera.getPicture(this.options).then(
      (res) => {
        this.cameraPreview.stopCamera();
        this.cleanCameraUI();
        resolve({ base64: "data:image/png;base64," + res, source: "gallery" });
      },
      (err) => {
        this.cleanCameraUI();
        reject("Error");
      }
    );
  }
  cleanCameraUI() {
    var wrapper = document.getElementsByClassName("preview-overlay")[0],
      bodyContent = document.getElementsByTagName("app-root")[0];
    wrapper.classList.remove("camera-preview-img");
    document.body.removeChild(wrapper);
    document.querySelector("html").classList.remove("camera-preview-mode");
    bodyContent["style"].visibility = "visible";
    document.body.classList.remove("camera-preview-mode");
  }
  takePicture() {
    this.cameraPreview.startCamera(this.cameraPreviewOpts);

    document.body.classList.add("camera-preview-mode");
    var bodyContent = document.getElementsByTagName("app-root")[0];
    bodyContent["style"].visibility = "hidden";

    // Create a rectangle & buttons
    var rect = document.createElement("div");
    var take_pic_btn = document.createElement("button");
    take_pic_btn.type = "button";
    take_pic_btn.name = "takePicture";
    take_pic_btn.value = "takePicture";

    var use_pic_btn = document.createElement("button");
    use_pic_btn.type = "button";
    use_pic_btn.name = "usePicture";
    use_pic_btn.value = "usePicture";

    var retake_pic_btn = document.createElement("button");
    retake_pic_btn.type = "button";
    retake_pic_btn.name = "reTakePicture";
    retake_pic_btn.value = "reTakePicture";

    // Add styles
    rect.className += "camera-preview-div";
    take_pic_btn.className += "take_pic_class";
    use_pic_btn.className += "use_pic_class";
    retake_pic_btn.className += "retake_pic_class";

    // Append to body section
    document.body.appendChild(rect);
    document.body.appendChild(take_pic_btn);
    document.body.appendChild(use_pic_btn);
    document.body.appendChild(retake_pic_btn);

    use_pic_btn.style.visibility = "hidden";
    retake_pic_btn.style.visibility = "hidden";

    var croppedBase64Img = "";

    // Get rectangle coordinates
    var rect_coords = rect.getBoundingClientRect();
    var x_coord = rect_coords.left,
      y_coord = rect_coords.top;

    var _this = this;
    take_pic_btn.onclick = function () {
      // Get rectangle size
      var rect_width = rect.offsetWidth,
        rect_height = rect.offsetHeight;

      // take a picture
      _this.cameraPreview.takePicture(_this.pictureOpts).then(
        (imageData) => {
          _this.cameraPreview.stopCamera();
          _this.picture = imageData[0];

          _this.crop(
            _this.picture,
            rect_width,
            rect_height,
            x_coord,
            y_coord,
            function (cropped_img_base64) {
              rect.style.visibility = "visible";
              take_pic_btn.style.visibility = "hidden";
              rect.style.backgroundImage = "url(" + cropped_img_base64 + ")";
              rect.classList.add("camera-preview-img");

              use_pic_btn.style.visibility = "visible";
              retake_pic_btn.style.visibility = "visible";

              croppedBase64Img = cropped_img_base64;
            }
          );
        },
        (err) => {
          console.log(err);
          document.body.classList.remove("camera-preview-mode");
        }
      );
    };

    retake_pic_btn.onclick = function () {
      document.body.removeChild(rect);
      document.body.removeChild(take_pic_btn);
      document.body.removeChild(use_pic_btn);
      document.body.removeChild(retake_pic_btn);

      document.body.classList.remove("camera-preview-mode");

      _this.takePicture();
    };

    use_pic_btn.onclick = function () {
      document.body.removeChild(rect);
      document.body.removeChild(take_pic_btn);
      document.body.removeChild(use_pic_btn);
      document.body.removeChild(retake_pic_btn);

      document.body.classList.remove("camera-preview-mode");

      _this.rotate(croppedBase64Img, 270, function (rotatedImgData) {
        bodyContent["style"].visibility = "visible";
        document.body.classList.remove("camera-preview-mode");
        _this.resizeImage(rotatedImgData, function (imgData) {
          if (_this.callbackMethod) _this.callbackMethod(imgData);
        });
      });
    };
  }

  rotate(srcBase64, degrees, callback) {
    const canvas = document.createElement("canvas");
    let ctx = canvas.getContext("2d");
    let image = new Image();

    image.onload = function () {
      canvas.width = degrees % 180 === 0 ? image.width : image.height;
      canvas.height = degrees % 180 === 0 ? image.height : image.width;

      ctx.translate(canvas.width / 2, canvas.height / 2);
      ctx.rotate((degrees * Math.PI) / 180);
      ctx.drawImage(image, image.width / -2, image.height / -2);

      callback(canvas.toDataURL());
    };

    image.src = srcBase64;
  }

  crop(base64PictureData, rect_width, rect_height, x_coord, y_coord, callback) {
    // image variable will contain ORIGINAL image
    var image = new Image();

    // canvas variable will contain CROPPED image
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");

    // Load original image onto image object
    image.src = "data:image/png;base64," + base64PictureData;
    image.onload = function () {
      // Map rectangle onto image taken
      var x_axis_scale = image.width / window.screen.width;
      var y_axis_scale = image.height / window.screen.height;
      // INTERPOLATE
      var x_coord_int = x_coord * x_axis_scale;
      var y_coord_int = y_coord * y_axis_scale;
      var rect_width_int = rect_width * x_axis_scale;
      var rect_height_int = rect_height * y_axis_scale;

      if (rect_width_int > rect_height_int) {
        var ratio = Math.max(x_axis_scale, y_axis_scale);
        rect_width_int = rect_width * ratio;
        rect_height_int = rect_height * ratio;
      }

      // Set canvas size equivalent to cropped image size
      canvas.width = rect_width_int;
      canvas.height = rect_height_int;

      ctx.drawImage(
        image,
        x_coord_int,
        y_coord_int, // Start CROPPING from x_coord(interpolated) and y_coord(interpolated)
        rect_width_int,
        rect_height_int, // Crop interpolated rectangle
        0,
        0, // Place the result at 0, 0 in the canvas,
        rect_width_int,
        rect_height_int
      ); // Crop interpolated rectangle

      // Get base64 representation of cropped image
      var cropped_img_base64 = canvas.toDataURL();

      // Now we are ready to send cropped image TO SERVER
      if (callback) callback(cropped_img_base64);

      return cropped_img_base64;
    };
  }

  registerDeviceAuth() {
    this._nativeStorage.storeData("deviceAuth", "true").then((value) => {});
  }
  deRegisterDeviceAuth() {
    this._nativeStorage.removeDate("deviceAuth").then((value) => {});
  }

  /**
   * To check push notification enabled
   */
  checkPushNotificationEnabled() {
    this.diagnostic
      .isRemoteNotificationsEnabled()
      .then((isEnabled) => {
        this.isRemoteNotificationsEnabled = isEnabled;
      })
      .catch((e) => console.error(e));
  }
  //Checks if NFC hardware is present on device.
  checkNFCPresent() {
    this.diagnostic
      .isNFCPresent()
      .then((isEnabled) => {
        this.isNFCPresent = isEnabled;
        // alert(this.isNFCPresent);
      })
      .catch((e) => console.error(e));
  }

  //Checks if NFC is available to the app. Returns true if the device has NFC capabilities AND if NFC setting is switched on.
  checkNFCAvailable() {
    this.diagnostic
      .isNFCAvailable()
      .then((isEnabled) => {
        this.isNFCAvailable = isEnabled;
        // alert(this.isNFCAvailable);
      })
      .catch((e) => console.error(e));
  }
  //Displays NFC settings to allow user to enable NFC.
  enableNFCSettings() {
    this.diagnostic.switchToNFCSettings();
    // alert("nfc settings");
  }
  /**
   * To check fingure print / face id available on device
   */
  checkTouchIDAvailable() {
    if (this.device.platform.toLowerCase() == "ios") {
      this.touchId.isAvailable().then(
        (res) => this.didAuthAvailable(res),
        (err) => {
          this.didAuthAvailable(err);
        }
      );
    } else if (this.device.platform.toLowerCase() == "android") {
      this.androidFingerprintAuth
        .isAvailable()
        .then((result) => {
          if (result.isAvailable) {
            this.didAuthAvailable("touch");
          } else {
            this.didAuthAvailable(null);
          }
        })
        .catch((error) => {
          this.didAuthAvailable(error);
        });
    }
  }

  didAuthAvailable(result) {
    if (result == "face") {
      this.isFaceIDAvailable = true;
      this.isDeviceAuthAvailable = true;
    } else if (
      result == "touch" ||
      result == "finger" ||
      result == "biometric"
    ) {
      this.isFaceIDAvailable = false;
      this.isTouchIDAvailable = true;
      this.isDeviceAuthAvailable = true;
    } else {
      console.log("face id / touch id not available!");
    }

    this.send_appReady();
  }

  /**
   * prompt user device authentication
   */
  showTouchIDAuth() {
    if (this.device.platform.toLocaleLowerCase() == "ios") {
      this.touchId
        .verifyFingerprint("Touch your finger on sensor to login.")
        .then(
          () => {
            this.deviceAuthSuccess(true);
          },
          (err) => {
            this.deviceAuthSuccess(false);
          }
        );
    } else if (this.device.platform.toLocaleLowerCase() == "android") {
      this.androidFingerprintAuth
        .encrypt({
          clientId: "RetailBanking",
          maxAttempts: 5,
          dialogTitle: "Login with touch ID",
          dialogMessage: "Touch your finger on sensor to login.",
        })
        .then((res) => {
          if (res.withFingerprint) {
            console.log("Successfully encrypted credentials.");
            console.log("Encrypted credentials: " + res.token);
            this.deviceAuthSuccess(true);
          } else if (res.withBackup) {
            console.log("Successfully authenticated with backup password!");
            this.deviceAuthSuccess(true);
          } else {
            console.log("Didn't authenticate!");
            this.deviceAuthSuccess(false);
          }
        })
        .catch((err) => {
          if (
            err === this.androidFingerprintAuth.ERRORS.FINGERPRINT_CANCELLED
          ) {
            console.log("Fingerprint authentication cancelled");
          } else console.error(err);
          this.deviceAuthSuccess(false);
        });
    }
  }

  deviceAuthSuccess(res) {
    this.deviceAuth.emit(res);
  }

  forceExitApp() {
    navigator["app"].exitApp();
  }

  getDeviceId(): any {
    return this.isHybrid() ? this.deviceID : window["browserFingerprint"];
  }

  showCustomAlert(data) {
    var title = data.title || "";

    this.dialogs
      .alert(data.message, title)
      .then(() => data.onAlertDismiss())
      .catch((e) => console.log("Error displaying dialog", e));
  }

  deviceIsRooted(result) {
    var _this = this;
    if (this.bypassIRoot) result = false;
    if (result) {
      this.showCustomAlert({
        message: "Application won't work on rooted device",
        onAlertDismiss: this.forceExitApp,
      });
    } else {
      window.plugins.uniqueDeviceID.get(
        function (udid) {
          _this.deviceID = udid;
          sessionStorage.setItem("deviceId", udid);
        },
        function (error) {
          console.log("device id fetch error...");
        }
      );

      this.checkPushNotificationEnabled();
      this.checkTouchIDAvailable();
    }
  }

  initialize() {
    var _this = this;

    window.Keyboard.hideFormAccessoryBar(true);

    if (this.device.isVirtual || this.device.serial == "android") {
      this.showCustomAlert({
        message: "Application won't work on virtual device",
        onAlertDismiss: this.forceExitApp,
      });

      return;
    }

    window.IRoot.isRooted(
      function (rooted) {
        if (rooted) {
          _this.deviceIsRooted(rooted);
        } else {
          if (_this.platform.is("android")) {
            window.IRoot.isRootedWithBusyBox(
              function (rooted) {
                _this.deviceIsRooted(rooted);
              },
              function (error) {
                _this.deviceIsRooted(true);
              }
            );
          } else {
            _this.deviceIsRooted(rooted);
          }
        }
      },
      function (error) {
        _this.deviceIsRooted(true);
      }
    );
  }

  send_appReady() {
    console.log("-- app ready -- ");
    this.observerable.checkAppConfig();

    if (this.doEnableSecureHTTP) {
      this.secureHTTP.setServerTrustMode("pinned").then(
        (res) => console.log("SSL pinned success"),
        (err) => console.log("SSL pinned error")
      );
    }

    window.addEventListener(
      "keyboardWillShow",
      this.keyboardWillShow.bind(this)
    );
    window.addEventListener("keyboardDidShow", this.keyboardDidShow.bind(this));
    window.addEventListener("keyboardDidHide", this.keyboardDidHide.bind(this));
    window.addEventListener(
      "keyboardHeightWillChange",
      this.keyboardHeightWillChange.bind(this)
    );

    this.getAppVersion();
    //this.appReady.emit();
  }

  private getAppVersion() {
    const versionNumber$ = from(this._appVersion.getVersionNumber());
    const buildNumber$ = from(this._appVersion.getVersionCode());
    const packageName$ = from(this._appVersion.getPackageName());

    combineLatest([versionNumber$, buildNumber$, packageName$]).subscribe(
      ([versionNumber, buildNumber, packageName]) => {
        this.appVersionInfo = {
          packageName: packageName,
          versionNumber: versionNumber,
          buildNumber: buildNumber,
        };
        this.appReady.emit();
      }
    );
  }

  /**
   * will be run each time when keyboard is about to be shown.
   */
  keyboardWillShow() {
    document.body.classList.add("open-keypad");
    /*if ($('.min-height').length) {
            window.scrollTo({top:0});
        }*/
  }

  /**
   * will be run each time keyboard is shown.
   */
  keyboardDidShow() {
    //document.activeElement.scrollIntoView();
    if (document.activeElement.getAttribute("rel") != "tran-search-input")
      window.Keyboard.updateViewScroll();

    if ($(".min-height").length) {
      //window.scrollTo({top:0});
      const updateScreenHeight = new CustomEvent("updateScreenHeight", {});
      window.dispatchEvent(updateScreenHeight);
    }
    if (
      document.activeElement.parentElement.classList.contains(
        "amount-field-wrapper"
      )
    ) {
      if (!$("html.open-tran-search").length)
        document.activeElement.scrollIntoView();
    }
  }

  /**
   * will be run each time keyboard is closed.
   */
  keyboardDidHide() {
    //window.Keyboard.updateViewScroll();
    document.body.classList.remove("open-keypad");
    if ($(".min-height").length) {
      const updateScreenHeight = new CustomEvent("updateScreenHeight", {});
      window.dispatchEvent(updateScreenHeight);
    }
  }

  keyboardHeightWillChange(event) {
    this.keyboardHeight = event.keyboardHeight;
  }

  hideFormAccessoryBar(doHide) {
    //window.Keyboard.hideFormAccessoryBar(doHide);
  }

  resizeImage(base64Str, callback) {
    var img = new Image();

    img.onload = function () {
      var canvas = document.createElement("canvas");
      var MAX_WIDTH = 200;
      var MAX_HEIGHT = 200;
      var width = img.width;
      var height = img.height;

      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width;
          width = MAX_WIDTH;
        }
      } else {
        if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
        }
      }
      canvas.width = width;
      canvas.height = height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, width, height);
      callback(canvas.toDataURL("image/jpeg"));
    };
    img.src = base64Str;
  }

  /**
   *
   * @returns {publicKey:Base64Data, privateKey:Base64Data}
   */
  generatePairKey() {
    const crypt = new JsEncryptModule.JSEncrypt({
      default_key_size: this.KEY_SIZE,
    });
    const privateKey = crypt.getPrivateKeyB64();
    const publicKey = crypt.getPublicKeyB64();

    return {
      privateKey: privateKey,
      publicKey: publicKey,
    };
  }

  /**
   *
   * @param challengeCode //random string
   * @param key //private key
   */
  encrypt(challengeCode, key) {
    var rsa = new RSAKey();
    rsa.readPrivateKeyFromPEMString(key);
    let hashAlg = this.RSA_ALG;
    let hSig = rsa.sign(challengeCode, hashAlg);
    let signature = this.linebrk(hSig, 64);
    return btoa(hSig);
  }

  linebrk(c, d) {
    var a = "";
    var b = 0;
    while (b + d < c.length) {
      a += c.substring(b, b + d) + "\n";
      b += d;
    }
    return a + c.substring(b, c.length);
  }

  generateChallengeCode(length) {
    var result = [];
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result.push(
        characters.charAt(Math.floor(Math.random() * charactersLength))
      );
    }
    return result.join("");
  }

  requestPushNotificationPermission() {
    this.diagnostic.requestRemoteNotificationsAuthorization().then((status) => {
      if (status == this.diagnostic.permissionStatus.GRANTED) {
        this.isRemoteNotificationsEnabled = true;
        console.log("granted");
      } else {
        this.isRemoteNotificationsEnabled = false;
        console.log("denied");
      }
    });
  }

  requestCameraPermission() {
    this.diagnostic.isCameraAuthorized(false).then(
      (authorized) => {
        if (authorized) {
          //no action
        } else {
          this.diagnostic.requestCameraAuthorization(false).then((status) => {
            if (status == this.diagnostic.permissionStatus.GRANTED) {
              console.log("granted");
            } else {
              console.log("denied");
            }
          });
        }
      },
      (error) => {
        console.error("The following error occurred: " + error);
      }
    );
  }
}
